import {IoSearchOutline} from 'react-icons/io5'

const InfoTitle = ({infoValue,onClickTitle}) => {
    const click = (e) => {
        e.preventDefault()
        onClickTitle(infoValue)
    }

    return (
        <div onClick={click} className="infotitle-cont">
            <IoSearchOutline size={15} color={'gray'} />
            <span className="infotitle-text">{infoValue}</span>
        </div>
    )
}

export default InfoTitle
